import './wholesale-price.scss';
